import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <h5>DevCoski</h5>
            <p>
              {"Soluções digitais sob medida para o futuro da sua empresa. Sistemas ágeis, eficientes e escaláveis."}
            </p>
          </div>
          <div className="footer-links">
            <h5>{"Navegação"}</h5>
            <ul>
              <li>
                <a href="#inicio">{"Início"}</a>
              </li>
              <li>
                <a href="#recursos">Recursos</a>
              </li>
              <li>
                <a href="#sobre">Sobre</a>
              </li>
              <li>
                <a href="#contato">Contato</a>
              </li>
            </ul>
          </div>
          <div className="footer-contact">
            <h5>Contato</h5>
            <address>
              <p>Santos, SP - Brasil</p>
              <p>contato@devcoski.tech</p>
              <p>(13) 99213-6446</p>
            </address>
          </div>
        </div>
        <hr className="footer-divider" />
        <div className="footer-bottom">
          <p>{"\u00A9 2025 DevCoski. Todos os direitos reservados."}</p>
          <a className="footer-privacy-link" href="/politica-de-privacidade">Política de Privacidade</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
